import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import MySubscription from './MySubscription';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data } = state.dev;
  return {
    isLoading,
    data,
  };
}

const Styled = withStyles(styles)(MySubscription);

export default connect(
  mapStateToProps,
)(Styled);
